import Carousell from './Carousell'

export default Carousell
